export type PostCreationSource =
  "composer" | "bulk-create" | "single-conversion";

export function getPostCreationSource({
  isBulkCreate,
  isLogicalCreation,
  isSingleConversion = false,
}: {
  isBulkCreate: boolean;
  isLogicalCreation: boolean;
  isSingleConversion?: boolean;
}): PostCreationSource | undefined {
  if (isBulkCreate) {
    return "bulk-create";
  }
  if (isLogicalCreation) {
    return "composer";
  }
  return isSingleConversion ? "single-conversion" : undefined;
}

export function withPostCreationSource<T extends object>(
  payload: T,
  context: {
    isBulkCreate: boolean;
    isLogicalCreation: boolean;
    isSingleConversion?: boolean;
  }
): T & { creationSource?: PostCreationSource } {
  const creationSource = getPostCreationSource(context);
  return creationSource ? { ...payload, creationSource } : payload;
}
